import {
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { getColors } from "./bookings.styles";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import EventBusyOutlinedIcon from "@mui/icons-material/EventBusyOutlined";

const BookingRowMenu = ({
  anchorEl,
  open,
  onClose,
  onViewDetails,
  onEditBooking,
  onDownloadReceipt,
  onCancelAppointment,
}) => {
  const theme = useTheme();
  const colors = getColors(theme);
  const primaryColor = theme.palette.primary.main;

  const handleMenuItemClick = (action) => {
    onClose();
    action?.();
  };

  const menuItemSx = {
    py: 2,
    px: 3,
    gap: 2,
    "&:hover": {
      bgcolor: colors.bgPrimary,
    },
  };

  const iconSx = {
    fontSize: 20,
    color: colors.textMuted,
  };

  const textSx = {
    fontSize: 15,
    fontWeight: 500,
    color: colors.textPrimary,
  };

  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      slotProps={{
        paper: {
          sx: {
            mt: 1,
            borderRadius: 3,
            boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
            border: `1px solid ${colors.borderLight}`,
            minWidth: 220,
            py: 1,
          },
        },
      }}
    >
      <MenuItem
        onClick={() => handleMenuItemClick(onViewDetails)}
        sx={menuItemSx}
      >
        <ListItemIcon sx={{ minWidth: 32 }}>
          <VisibilityOutlinedIcon sx={iconSx} />
        </ListItemIcon>
        <ListItemText
          primary="View Full Details"
          slotProps={{ primary: { sx: textSx } }}
        />
      </MenuItem>

      <MenuItem
        onClick={() => handleMenuItemClick(onEditBooking)}
        sx={menuItemSx}
      >
        <ListItemIcon sx={{ minWidth: 32 }}>
          <EditOutlinedIcon sx={{ ...iconSx, color: primaryColor }} />
        </ListItemIcon>
        <ListItemText
          primary="Edit Booking"
          slotProps={{ primary: { sx: { ...textSx, color: primaryColor } } }}
        />
      </MenuItem>

      <Divider sx={{ my: 1.5 }} />

      <MenuItem
        onClick={() => handleMenuItemClick(onCancelAppointment)}
        sx={{
          ...menuItemSx,
          "&:hover": {
            bgcolor: colors.dangerLight,
          },
        }}
      >
        <ListItemIcon sx={{ minWidth: 32 }}>
          <EventBusyOutlinedIcon sx={{ ...iconSx, color: colors.danger }} />
        </ListItemIcon>
        <ListItemText
          primary="Cancel Appointment"
          slotProps={{ primary: { sx: { ...textSx, color: colors.danger } } }}
        />
      </MenuItem>
    </Menu>
  );
};

export default BookingRowMenu;
